import * as Yup from 'yup'

export const initialValues = {
    email: '',
    password: '',
}

export const validationSchema = Yup.object().shape({
    password: Yup.string()
        .required('The password is required')
        .min(6, 'Password minimum is 6 characters'),
    email: Yup.string()
        .email('Email is invalid')
        .required('Email is required'),
})
